module.exports = __webpack_public_path__ + "img/dianji.09a1f89e.png";